import { render, staticRenderFns } from "./AboutEffectSizes.vue?vue&type=template&id=ce7339ae&"
import script from "./AboutEffectSizes.vue?vue&type=script&lang=js&"
export * from "./AboutEffectSizes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports